import React from 'react';
import { Button } from '@trello/nachos';
import { Icon, IconName } from 'app/common/components/controls';
import {
  Allocation,
  ExperimentDetailsObject,
} from 'app/gamma/src/types/experiment';

import styles from './experiment-details.less';

export interface ExperimentDetailsProps extends ExperimentDetailsObject {
  experimentName: string;
  onVariationOverride: (name: string) => void;
  onVariationRemove: () => void;
}

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('header_experiment_menu');

export const ExperimentDetails: React.FunctionComponent<ExperimentDetailsProps> = ({
  activeVariation,
  allocations,
  audienceSettings,
  experimentName,
  meta,
  onVariationOverride,
  onVariationRemove,
  variations,
}) => (
  <div className={styles.experimentDetails}>
    <h3>{format('experiment-name')}</h3>
    <p>{experimentName}</p>
    {meta && (
      <>
        <h3>{format('description')}</h3>
        {meta.image && (
          <p>
            <a rel="noopener noreferrer" href={meta.image} target="_blank">
              <img
                className={styles.image}
                src={meta.image}
                alt=""
                role="presentation"
              />
            </a>
          </p>
        )}
        {meta.description && <p>{meta.description}</p>}
        {meta.link && (
          <p>
            <a rel="noopener noreferrer" href={meta.link} target="_blank">
              {meta.link}
            </a>
          </p>
        )}
      </>
    )}

    <h3>{format('current-active-variation')}</h3>
    <p>{activeVariation}</p>
    <h3>{format('experiment-allocation')}</h3>
    <ul className={styles.detailsList}>
      {allocations.map(({ audience, allocation, used }: Allocation) => {
        return (
          <li key={`${audience}-${allocation}`}>
            {`${audience}: ${allocation * 100}% `}
            {used && <Icon small name={IconName.Check} />}
          </li>
        );
      })}
    </ul>
    {audienceSettings && [
      <h3 key="aud-settings">{format('audience-settings')}</h3>,
      <ul className={styles.detailsList} key="aud-settings-list">
        {Object.entries(audienceSettings).map(([key, value]) => {
          return <li key={key}>{`${key}: ${value}`}</li>;
        })}
      </ul>,
    ]}
    <h3>{format('variation-allocation')}</h3>
    <ul className={styles.detailsList}>
      {variations.map(({ name, percentage }) => {
        return <li key={name}>{`${name}: (${percentage}%)`}</li>;
      })}
    </ul>
    <hr />
    <h3>{format('override-variation')}</h3>
    <p>{format('override-variation-note')}</p>
    <ul className={styles.detailsList}>
      {variations.map(({ active, name }) => {
        return (
          <li key={name}>
            <Button
              isDisabled={active}
              appearance="primary"
              shouldFitContainer
              onClick={() => onVariationOverride(name)}
            >
              {name}
              {active && <Icon small name={IconName.Check} />}
            </Button>
          </li>
        );
      })}
    </ul>
    <hr />
    <h3>{format('remove-experiment-cookie')}</h3>
    <p>{format('remove-experiment-cookie-note')}</p>
    <Button appearance="danger" shouldFitContainer onClick={onVariationRemove}>
      {format('remove-experiment-cookie')}
    </Button>
  </div>
);
